import { motion } from "framer-motion";
import { Video, PlayCircle, Layers, Infinity as InfinityIcon } from "lucide-react";
import { FloatingMoon, FloatingCloud, SleepZ } from "./SleepDecorations";

const COMMUNITY_ITEMS = [
  {
    icon: Video,
    title: "Lives semanais com a Mariana",
    text: "Encontros ao vivo com a Mari para esclarecer dúvidas, ajustar a aplicação e direcionar cada caso. Você participa, faz perguntas e leva o que precisa pra noite seguinte.",
  },
  {
    icon: PlayCircle,
    title: "Gravações disponíveis quando você quiser",
    text: "Não conseguiu participar ao vivo? Toda live fica gravada e disponível no seu acesso. Você assiste no horário que cabe na sua rotina, no seu ritmo.",
  },
  {
    icon: Layers,
    title: "Conteúdos complementares ao longo do tempo",
    text: "À medida que novas perguntas surgem e novos contextos aparecem, materiais complementares são adicionados ao ecossistema. Você recebe sem custo adicional.",
  },
  {
    icon: InfinityIcon,
    title: "Acesso contínuo ao ecossistema",
    text: "Por 12 meses você não está sozinha. A Jornada do Sono não termina quando a última aula acaba. Ela continua acontecendo onde o método continua sendo aplicado.",
  },
];

export default function CommunitySection() {
  return (
    <section className="relative py-28 lg:py-32 bg-gradient-to-br from-[#2d1f43] via-[#3d2a5a] to-[#2d1f43] overflow-hidden">
      <div className="absolute inset-0 stars-bg opacity-25 pointer-events-none" />
      <FloatingMoon
        className="absolute top-16 right-[-30px]"
        size={220}
        tone="light"
      />
      <FloatingCloud
        className="absolute bottom-10 -left-12 text-[#a78bfa]/25 drift-slow"
        size={200}
      />
      <SleepZ
        className="absolute top-1/3 right-[18%] text-[#a78bfa]/40"
        size={48}
      />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[400px] rounded-full bg-violet-500/15 blur-[140px] pointer-events-none" />

      <div className="relative max-w-5xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center max-w-3xl mx-auto mb-14"
        >
          <h2 className="font-display text-4xl sm:text-5xl lg:text-[56px] text-white leading-[1.1]">
            Você não compra apenas um curso.
            <span className="block text-[#a78bfa] font-medium mt-3">
              Você passa a fazer parte da
            </span>
            <span className="block text-[#a78bfa] font-semibold italic">
              Comunidade Mariana Mello.
            </span>
          </h2>
          <p className="text-slate-200/85 text-base lg:text-lg leading-[1.75] mt-7 max-w-2xl mx-auto">
            Sono infantil muda à medida que o seu filho cresce. Por isso a
            Jornada não termina na última aula — ela continua acontecendo onde
            o método continua sendo aplicado.
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 gap-5 lg:gap-6 items-stretch">
          {COMMUNITY_ITEMS.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (i % 2) * 0.1 }}
              whileHover={{ y: -4 }}
              className="h-full rounded-3xl border border-white/10 bg-white/[0.04] hover:bg-white/[0.07] backdrop-blur-sm p-7 lg:p-8 transition-all duration-500 flex flex-col"
            >
              <div className="w-12 h-12 rounded-2xl bg-violet-400/20 border border-violet-400/30 flex items-center justify-center mb-5 shrink-0">
                <item.icon
                  className="w-6 h-6 text-[#c4b5fd]"
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="font-display text-xl lg:text-[22px] text-white leading-tight mb-3">
                {item.title}
              </h3>
              <p className="text-slate-300/85 text-[14.5px] leading-[1.7] flex-1">
                {item.text}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
